import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
	RegistratorCabinetDocument,
	ParamsDocument,
	ParamsDocumentsIds,
	ParamsDocumentsWithoutIdDocument,
	ParamsDocumentsWithoutNameGroup,
	DocumentFields,
} from 'Pages/registratorCabinet'
import { Callback } from 'Src/types/utilTypes'

type documentState = {
	isLoadingDoc: Partial<Record<DocumentFields, boolean>> // Вынести в отдельный тип
}

export const documentsInitialState: documentState = {
	isLoadingDoc: {},
}

export namespace DocumentsNS {
	export type LoadNewDocument = PayloadAction<{
		params: ParamsDocumentsWithoutIdDocument
		callback?: Callback
		errorCallback?: Callback
	}>
	export type UpdateDocument = PayloadAction<{
		params: ParamsDocument
		callback?: Callback
		errorCallback?: Callback
	}>
	export type DeleteDocument = PayloadAction<{
		params: Omit<ParamsDocument, 'file'>
		callback?: Callback
		errorCallback?: Callback
	}>
	export type SetDocument = PayloadAction<{
		document: RegistratorCabinetDocument | null
		nameGroup: string
	}>
	export type UpdateDocumentCustomer = PayloadAction<{
		params: ParamsDocumentsWithoutNameGroup
		callback?: Callback
		errorCallback?: Callback
	}>
	export type DeleteDocumentCustomer = PayloadAction<{
		params: ParamsDocumentsIds
		callback?: Callback
		errorCallback?: Callback
	}>
	export type SetIsLoadingDoc = PayloadAction<{
		fieldName: DocumentFields
		value: boolean
	}>
	export type DownloadAllDocuments = PayloadAction<{ id: number }>
}

export const documentSlice = createSlice({
	name: 'documents',
	initialState: documentsInitialState,
	reducers: {
		loadOne: (state, action: DocumentsNS.LoadNewDocument) => {},
		updateOne: (state, action: DocumentsNS.UpdateDocument) => {},
		deleteOne: (state, action: DocumentsNS.DeleteDocument) => {},
		setOne: (state, action: DocumentsNS.SetDocument) => {},
		updateOneCustomer: (state, action: DocumentsNS.UpdateDocumentCustomer) => {},
		deleteOneCustomer: (state, action: DocumentsNS.DeleteDocumentCustomer) => {},
		setIsLoading: (state, action: DocumentsNS.SetIsLoadingDoc) => {
			const { fieldName, value } = action.payload
			state.isLoadingDoc[fieldName] = value
		},
		clearIsLoading: (state) => {
			state.isLoadingDoc = {}
		},
		downloadAllDocuments: (state, action: DocumentsNS.DownloadAllDocuments) => {},
	},
})
